import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ReelLoader } from "@/components/ReelLoader";
import { getPendingPairing, clearPendingPairing } from "@/lib/guest";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        // clear the session_id fragment from the URL
        window.history.replaceState(null, "", window.location.pathname);
        await refreshUser();

        // carry a guest's last free pairing into their new account
        const pending = getPendingPairing();
        if (pending) {
          try {
            await api.post("/pairings", { ...pending, is_public: false });
            clearPendingPairing();
            toast.success(`Saved your "${pending.movie_title}" pairing to your collection!`);
          } catch {
            clearPendingPairing();
          }
        }
        toast.success("Signed in with Google!");
        navigate("/pairings", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen pt-24" data-testid="auth-callback">
      <ReelLoader label="Signing you in..." />
    </div>
  );
}
